<template>
  <section class="section section--hello" id="hello">
    <div class="section__inner">
      <div class="block">
        <a class="pre" href="#intro"> <span>#0</span>Hello </a>
        <h2>Hello</h2>
        <ul class="anchornav">
          <li>
            <a href="#intro">
              Intro
              <span>#1 What is going on?</span>
            </a>
          </li>
          <li>
            <a href="#about">
              About
              <span>#2 Who is Snowie?</span>
            </a>
          </li>
          <li>
            <a href="#skills">
              Skills
              <span>#3 What are her skillsets?</span>
            </a>
          </li>
          <li>
            <a href="#portfolio">
              Portfolio
              <span>#4 What has she done?</span>
            </a>
          </li>
          <li>
            <a href="#contact">
              Contact
              <span>#5 Write her a message</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Hello"
};
</script>

<style lang="scss">
.section--hello {
  background-color: $theme1;
  color: #181818;
}
.anchornav {
  margin: 0;
  padding: 0;
  list-style: none;

  li {
    display: block;
    &::after {
      content: "";
      width: 1.3rem;
      display: block;
      height: 2px;
      background: black;
    }

    &:last-child::after {
      display: none;
    }
  }

  a {
    display: block;
    padding: 1em 0;
    font-family: $font-sans;
    text-transform: uppercase;
    font-size: 12px;
    letter-spacing: 1.4px;
    color: inherit;
    transition: $transition;

    span {
      display: inline;
      padding: 0.5em 0 0;
      opacity: 0.3;
      letter-spacing: normal;
      font-family: $font-serif;
      text-transform: none;
    }

    &:hover {
      color: $primary;
      span {
        opacity: 1;
        color: #181818;
      }
    }
  }
}
</style>
